import axios from "axios";
import lstModules from "common/json/lstModules.json"

var httpURLCommon = lstModules['timeTable'].url + ':' + lstModules['timeTable'].port
// var httpURLCommon = lstModules['local'].url + ':' + lstModules['local'].port

var screenId = 33;
var tokenId = localStorage.getItem('tokenid');

export const getCommonClsListSvc = (cbListCommonClsResponse) => {
    var obj = { status: "Success", message: "" }
    // console.log(httpURLCommon + "/sms/tt/v2/common_cls/list")
    axios({
        url: httpURLCommon + "/sms/tt/v2/common_cls/list",
        method: "POST",
        headers: { 'tokenid': tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstCommonCls = response.data.lstCommonCls;
        cbListCommonClsResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbListCommonClsResponse(obj);
    })
}

export const listSectionPeriodsSvc = (pCommonClsId, pSubId, cbSectionPeriodResponse) => {
    var obj = { status: "Success", message: "" }
    var formData = new FormData();
    // console.log(pCommonClsId, pSubId)
    formData.append("commonClsId", pCommonClsId);
    formData.append("subId", pSubId);
    // console.log(httpURLCommon + "/sms/tt/v2/common_cls/list_section", formData)
    axios({
        url: httpURLCommon + "/sms/tt/v2/common_cls/list_section",
        method: "POST",
        headers: { 'tokenid': tokenId },
        data: formData,
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstSection = response.data.lstSection;
        cbSectionPeriodResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbSectionPeriodResponse(obj);
    })
}



export const listEligibleTchSvc = (pSubId, pLstSection, cbListTchResponse) => {
    var obj = { status: "Success", message: "" }
    var formData = new FormData();
    var objCommonClass = { subId: pSubId, lstSection: pLstSection }
    formData.append("objCommonCls", JSON.stringify(objCommonClass))
    axios({
        url: httpURLCommon + "/sms/tt/v2/common_cls/list_eligible_tch",
        method: "POST",
        data: formData,
        headers: { tokenid: tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstTch = response.data.lstTch;
        cbListTchResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbListTchResponse(obj);
    })
}

export const saveCommonClsSvc = (formData, cbSaveCommonCls) => {
    var obj = { status: "Success", message: "" }
    
    axios({
        url: httpURLCommon + "/sms/tt/v2/common_cls/save",
        method: "POST",
        data: formData,
        headers: { tokenId: tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cbSaveCommonCls(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbSaveCommonCls(obj);
    })
}

export const deleteCommonClsSvc = (pCommonClsId, cbDeleteCommonCls) => {
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURLCommon + "/sms/tt/v2/common_cls/delete",
        method: "POST",
        params: { commonClsId: pCommonClsId },
        headers: { tokenId: tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cbDeleteCommonCls(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbDeleteCommonCls(obj);
    })
}


export function getLstSubjectSvc(cb) {
    var status = 'Success'
    var obj = { status: status };
    axios({
        url: httpURLCommon + "/sms/mst/sub/list",
        method: "POST",
        params: {},
        headers: { 'tokenid': tokenId },
        withCredentials: true
    }).then((response) => {
        var data = response.data;
        if (data.SvcStatus === 'Success') {
            obj.message = data.SvcMsg;
            obj.status = data.SvcStatus;
            obj.lstSubject = data.lstSubject;
        } else {
            obj.message = data.SvcMsg;
            obj.status = data.SvcStatus;
        }
        cb(obj)
    }).catch((error) => {
        obj.status = 'Exception';
        obj.message = error;
        cb(obj)
    });

}

export const getCommonClsListSvc2 = (cbListCommonClsResponse) => {
    var obj = { status: "Success", message: "" }
    // console.log(httpURLCommon + "/sms/tt/v4/common_cls/list")
    axios({
        url: httpURLCommon + "/sms/tt/v4/common_cls/list",
        method: "POST",
        headers: { 'tokenid': tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstCommonCls = response.data.lstCommonCls;
        cbListCommonClsResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbListCommonClsResponse(obj);
    })
}

export const saveCommonClsSvc2 = (formData, cbSaveCommonCls) => {
    var obj = { status: "Success", message: "" }
    
    axios({
        url: httpURLCommon + "/sms/tt/v4/common_cls/save",
        method: "POST",
        data: formData,
        headers: { tokenId: tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cbSaveCommonCls(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbSaveCommonCls(obj);
    })
}
